import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getAvailableCreditsTotal } from "app/pages/Account/MyCoupons/couponSelector";
import SearchEngineCreditBanner from "app/pages/PrePackage/components/SearchEngineCreditBanner/SearchEngineCreditBanner";

const SearchEngineCreditBannerContainer = ({ totalCredit }) => (
	<SearchEngineCreditBanner totalCredit={totalCredit} />
);

SearchEngineCreditBannerContainer.propTypes = {
	totalCredit: PropTypes.any,
};

const mapStateToProps = state => ({
	totalCredit: getAvailableCreditsTotal(state),
});

export default connect(mapStateToProps)(SearchEngineCreditBannerContainer);
